import styled from 'styled-components'

const Separator = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
`

export default Separator
